module.exports = __webpack_public_path__ + "static/media/fz_slotedit_en_US.759c352e.png";